import { loadScript, loadInlineScript } from "./utils";

const kundo = {
    loadKundoScript: async function () {
        return await loadScript('https://static-chat.kundo.se/chat-js/org/705/widget.js');

    },
    loadInlineKundoScript: function () {
        return loadInlineScript("(function (w) {w.$kundo_chat = w.$kundo_chat || {}; w.$kundo_chat.custom_texts = {START_TEXT: 'Chatta med oss',};}(this))");

    },

    show: function () {
        window.setTimeout(() => {
            if (window.$kundo_chat) {
                window.$kundo_chat.show_widget();
            }
        }, 500)

    },
    hide: function () {
        window.setTimeout(() => {
            if (window.$kundo_chat) {
                window.$kundo_chat.hide_widget();

            }
        }, 500)
    },

    loadChatScript: function (scriptContent) {
        try {
            let tempDiv = document.createElement("div");
            tempDiv.innerHTML = scriptContent.trim();

            let scriptElement = tempDiv.querySelector("script");
            if (!scriptElement) {
                console.warn("No script tag found in the script content.");
                return;
            }

            if (scriptElement.id && document.getElementById(scriptElement.id)) {
                console.log("Script with ID", scriptElement.id, "is already loaded.");
                return;
            }

            let newScript = document.createElement("script");
            Array.from(scriptElement.attributes).forEach(attr => {
                newScript.setAttribute(attr.name, attr.value);
            });

            if (scriptElement.innerHTML) {
                newScript.innerHTML = scriptElement.innerHTML;
            }

            document.body.appendChild(newScript);

        } catch (error) {
            console.warn("Failed to execute the chat script:", error);
        }
    }
};

export { kundo };